module.exports = __webpack_public_path__ + "img/eq-skin-of-viper.ac401c9d.png";